module.exports = {
	"1": "0xB761C26d6Ade3Da1c6a4313C785b76B90cae702e",
	"2": "0x3d527CF313c00dc3886BF00960B80dfff5C04BD8",
	"3": "0xdb6690E037Df8FEbc7D738C6abD50Da0a8609F7e",
	"4": "0xF7fD77cA8809378D8da48C86E0abacC395D1Ff63",
	"5": "0x481e0423347aAfe0b45A6Ca60fB873563DACEb0c",
	"ethernaut": "0x94849980c5E53Eed5D4778f3890bAAF7B535B13a"
};


//////////////////
// WEBPACK FOOTER
// ./gamedata/deploy.ropsten.json
// module id = 1523
// module chunks = 0